/** Clinic operates in India — always use IST for "today" and calendar dates. */
export const CLINIC_TIMEZONE = 'Asia/Kolkata';

/** Today's date as YYYY-MM-DD in clinic timezone (not UTC). */
export function todayDateString(timeZone = CLINIC_TIMEZONE): string {
  return new Intl.DateTimeFormat('en-CA', { timeZone }).format(new Date());
}

/** Format API time (HH:mm or HH:mm:ss) for queue display e.g. "12:00 PM". */
export function formatDisplayTime(value: unknown): string {
  if (!value) return '';

  if (typeof value === 'string') {
    const timeMatch = value.trim().match(/^(\d{1,2}):(\d{2})(?::\d{2})?$/);
    if (timeMatch) {
      const hours = Number(timeMatch[1]);
      const minutes = timeMatch[2];
      const period = hours >= 12 ? 'PM' : 'AM';
      const hour12 = hours % 12 || 12;
      return `${hour12}:${minutes} ${period}`;
    }
  }

  const date = new Date(value as string | number | Date);
  if (Number.isNaN(date.getTime())) return String(value);

  return date.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
}

/** Add/subtract calendar days from a YYYY-MM-DD string (timezone-safe). */
export function shiftDateString(dateStr: string, days: number): string {
  const [y, m, d] = dateStr.split('-').map(Number);
  const dt = new Date(Date.UTC(y, m - 1, d + days));
  return dt.toISOString().slice(0, 10);
}

function pad2(value: number): string {
  return String(value).padStart(2, '0');
}

/**
 * Hourly walk-in window for appointment create.
 * After 11 PM, end_time must stay valid H:i (never "24:00") — use 23:59.
 */
export function buildHourlyAppointmentWindow(now = new Date()): {
  start_time: string;
  end_time: string;
} {
  const hour = now.getHours();
  const start_time = `${pad2(hour)}:00`;

  if (hour >= 23) {
    return { start_time, end_time: '23:59' };
  }

  return {
    start_time,
    end_time: `${pad2(hour + 1)}:00`,
  };
}

